import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { PROFILE } from '../../statics/localStorage';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { toast } from 'sonner';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { IconLogout } from '@tabler/icons-react';

const ProfileDropdown = () => {

    const profileData = PROFILE();
    const navigate = useNavigate();

    async function onLogout() {
        loadingShow();
        let resp = await getApi(urlApi.logOut);
        loadingHide();
        if (resp.responseCode === 200) {
            localStorage.removeItem('advy-token');
            localStorage.removeItem('admin-access-list');
            localStorage.removeItem('advy-a-l-t');
            navigate('/login');
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <OverlayTrigger
            trigger="click"
            key={'instituteComponent'}
            placement={'bottom-end'}
            rootClose={true}
            overlay={
                <Popover id='popover-basic'>
                    <Popover.Header as="h5" className='text-sm'>{profileData?.name ?? "User"}</Popover.Header>
                    <Popover.Body>
                        <div className='mb-4'>
                            <Link to={'/settings'}> <p>Profile</p> </Link>
                        </div>
                        <ConfirmationModal
                            buttonComponent={<div className="flex items-center px-[10px] py-[4px] text-md rounded-[18px] font-medium mb-2 text-[var(--secondary-text)] hover:bg-[var(--cancel)] hover:text-white transition-all" >
                                <IconLogout size={18} />
                                <span className="!ml-1 text-xs">Logout</span>
                            </div>}
                            confirmationText={`Are You Sure Want To Logout ?`}
                            onConfirm={() => onLogout()}
                        />
                    </Popover.Body>
                </Popover>
            }
        >
            <button className='flex items-center justify-center' title='Profile'>
                <div className='flex items-center gap-2'>
                    <img src={profileData?.profilePic} alt='' className='h-8 aspect-square rounded-full object-cover' />
                    {profileData?.name && <p className='font-semibold text-sm capitalize mb-0'>{profileData?.name}</p>}
                </div>
            </button>
        </OverlayTrigger>
    )
}

export default ProfileDropdown